import type { StateCreator } from "zustand";

export interface HydrationSliceState {
  hasHydrated: boolean | undefined;
}

interface HydrationSliceActions {
  setHasHydrated: (
    nextHasHydrated:
      | HydrationSliceState["hasHydrated"]
      | ((
          currentHasHydrated: HydrationSliceState["hasHydrated"]
        ) => HydrationSliceState["hasHydrated"])
  ) => void;
}

export type HasHydratedSlice = HydrationSliceState & HydrationSliceActions;

export const createHasHydratedSlice: StateCreator<
  HasHydratedSlice,
  [["zustand/devtools", never]],
  [],
  HasHydratedSlice
> = (set) => ({
  hasHydrated: undefined,
  setHasHydrated: (nextHasHydrated) =>
    set((state) => ({
      hasHydrated:
        typeof nextHasHydrated === "function"
          ? nextHasHydrated(state.hasHydrated)
          : nextHasHydrated,
    })),
});
